import { render, staticRenderFns } from "./ReviewAvatar.vue?vue&type=template&id=066f993a&scoped=true&"
import script from "./ReviewAvatar.vue?vue&type=script&lang=js&"
export * from "./ReviewAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAvatar.vue?vue&type=style&index=0&id=066f993a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f993a",
  null
  
)

export default component.exports